import React, {
  useEffect,
  useGlobal,
  setGlobal,
  getGlobal,
  useState,
  useRef
} from "reactn";
import { makeStyles } from "@material-ui/styles";
import {
  Grid,
  Typography,
  Card,
  CardHeader,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  ListItem,
  MenuItem,
  Select
} from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import _ from "lodash";
import * as API from "../../api/api";
import moment from "moment";
import localization from "moment/locale/nl";
import Icon from "./components/Icons";
import clsx from "clsx";

moment.updateLocale("nl", localization);

const useStyles = makeStyles((theme) => ({
  root: {},
  tableRow: {},
  nameContainer: {},
  textField: { minWidth: 160 },

  hashCell: {
    width: "400",
    [theme.breakpoints.down("md")]: {
      maxWidth: 220,
      width: 220
    }
  },

  hashSelect: {
    width: "400",
    [theme.breakpoints.down("md")]: {
      maxWidth: 220
    }
  },

  hashSelectMenu: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  },

  serialSelect: {
    minWidth: 140
  },

  tableCellEllipsis: {
    maxWidth: 220,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    [theme.breakpoints.up("lg")]: {
      maxWidth: "220",
      whiteSpace: "nowrap"
    }
  },

  hashCellSmall: {
    maxWidth: 220,
    [theme.breakpoints.up("lg")]: {
      maxWidth: "none"
    }
  }
}));

const Notify = (props) => {
  const classes = useStyles();
  const { className } = props;

  const [user] = useGlobal("user");
  const [status] = useGlobal("status");
  const [global] = useGlobal();

  const devices = global?.devices || [];
  const deviceactionlogshash = global?.deviceactionlogshash || [];

  const [layout, setLayout] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [hideLayout] = useState(false);

  const [hash, setHash] = useState(() => user?.device_hash ?? "");
  const [today, setToday] = useState(
    new Date().toISOString().substring(0, 10)
  );
  const [serial, setSerial] = useState("");

  const hasDeviceHash = (value) =>
    devices.some((d) => String(d.device_hash) === String(value));

  const serialOptionsOf = (device) =>
    device ? Object.values(device.status || {}) : [];

  const hasSerialValue = (options, value) =>
    options.some((s, i) => String(s?.serial ?? i) === String(value));

  const hashChange = (event) => {
    const next = event.target.value ?? "";
    setHash(next);
    setSerial("");
  };

  const dayChange = (event) => setToday(event.target.value ?? "");
  const serialChange = (event) => setSerial(event.target.value ?? "");

  const layoutBusyRef = useRef(false);
  const isMountedRef = useRef(true);

  useEffect(() => {
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const getLayout = async () => {
    try {
      if (layoutBusyRef.current) return;
      layoutBusyRef.current = true;

      if (user?.device_hash) {
        const r = await API.doGetLayout({
          user,
          device_hash: user.device_hash,
          hideLayout
        });

        if (!isMountedRef.current) return;

        if (r && Object.keys(r).length > 0) {
          setLayout(r);
          await setLayoutStatusses(r);
        }
      }
    } catch (err) {
      console.log(err?.message || err);
    } finally {
      layoutBusyRef.current = false;
    }
  };

  const getData = async () => {
    try {
      if (user?.device_hash) {
        // plek voor extra dataload indien nodig
      }
    } catch (err) {
      console.log(err?.message || err);
    } finally {
      if (isMountedRef.current) setIsLoading(false);
    }
  };

  const getDevicesLogs = async (device_hash, until) => {
    const h = device_hash ?? "";
    const d = (until ?? today).toString().slice(0, 10);

    if (!h || !d) return;

    try {
      await API.getDeviceActionLogHash(h, d);
    } catch (err) {
      console.log(err);
    } finally {
      if (isMountedRef.current) setIsLoading(false);
    }
  };

  const setLayoutStatusses = async (layz) => {
    try {
      const n = _.cloneDeep(layz || layout);
      const st = getGlobal("status")?.status;

      if (st && st.length > 0 && Object.keys(n).length > 0) {
        for (let i in n) {
          const items = n[i].items;
          for (let x in items) {
            for (let z in st) {
              if (st[z].networkID === items[x].networkID) {
                items[x].status =
                  st[z].status.tubeStatus[parseInt(items[x].index, 10)];
              }
            }
          }
        }

        if (isMountedRef.current) setLayout(n);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    let isMounted = true;

    const loadData = async () => {
      try {
        if (!isMounted) return;
        setIsLoading(true);
        await API.getDevices();
        if (!isMounted) return;
        await getLayout();
        if (isMounted && hash) {
          await getDevicesLogs(hash, today);
        }
        if (isMounted) await getData();
      } catch (err) {
        console.error(err);
      } finally {
        if (isMounted) setIsLoading(false);
      }
    };

    loadData();

    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    const next = user?.device_hash ?? "";
    if (next && next !== hash) {
      setHash(next);
      setSerial("");
      setIsLoading(true);
      getDevicesLogs(next, today);
    }
  }, [user?.device_hash]);

  useEffect(() => {
    if (devices.length > 0 && !hasDeviceHash(hash)) {
      const first = devices[0].device_hash;
      setHash(first);
      setSerial("");
    }
  }, [devices]);

  useEffect(() => {
    if (!hash || !today) return;
    let isMounted = true;

    const reload = async () => {
      try {
        if (!isMounted) return;
        setGlobal({ status: [] });
        setLayout({});
        setIsLoading(true);
        await API.getDevices();
        if (isMounted) await getDevicesLogs(hash, today);
        if (isMounted) await getData();
        if (isMounted) await getLayout();
      } catch (err) {
        console.error(err);
      } finally {
        if (isMounted) setIsLoading(false);
      }
    };

    reload();

    return () => {
      isMounted = false;
    };
  }, [hash, today]);

  useEffect(() => {
    setLayoutStatusses();
  }, [status]);

  const selectedDevice = devices.find(
    (d) => String(d.device_hash) === String(hash)
  );
  const serialOptions = serialOptionsOf(selectedDevice);

  const hashValueForSelect = hasDeviceHash(hash) ? hash : "";
  const serialValueForSelect = hasSerialValue(serialOptions, serial)
    ? serial
    : "";

  return (
    <div className={classes.root}>
      <Grid container>
        {isLoading ? (
          <Grid
            style={{ marginTop: 100, marginBottom: 200 }}
            container
            direction="column"
            justifyContent="center"
            alignItems="center"
          >
            <CircularProgress color="primary" />
            <Typography style={{ marginTop: 50 }}>
              Moment, uw slurven worden opgehaald..
            </Typography>
          </Grid>
        ) : (
          <Grid item lg={12} md={12} xl={12} xs={12}>
            <Card className={clsx(classes.root, className)}>
              <CardHeader title="Uw Slurven" />
              <CardContent>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell width="150">HASH</TableCell>

                      <TableCell className={classes.hashCell}>
                        <Select
                          labelId="filter"
                          id="filter-select"
                          value={hashValueForSelect}
                          onChange={hashChange}
                          className={classes.hashSelect}
                          classes={{ select: classes.hashSelectMenu }}
                          MenuProps={{
                            PaperProps: {
                              style: {
                                maxWidth: 200
                              }
                            }
                          }}
                        >
                          <MenuItem disabled value="">
                            <em>Selecteer hash</em>
                          </MenuItem>
                          {devices.map((device, i) => (
                            <MenuItem
                              key={`hash-${i}-${device.device_hash}`}
                              value={device.device_hash}
                            >
                              {device.kenmerk} : {device.device_hash}
                            </MenuItem>
                          ))}
                        </Select>
                      </TableCell>

                      <TableCell>
                        <Select
                          labelId="serial"
                          id="filter-serial"
                          value={serialValueForSelect}
                          onChange={serialChange}
                          disabled={!selectedDevice}
                          className={classes.serialSelect}
                        >
                          <MenuItem disabled value="">
                            <em>Selecteer serial</em>
                          </MenuItem>
                          {serialOptions.map((s, i) => {
                            const val = s?.serial ?? i;
                            return (
                              <MenuItem
                                key={`serial-${selectedDevice?.device_hash}-${i}-${String(
                                  val
                                )}`}
                                value={val}
                              >
                                {String(val)}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </TableCell>

                      <TableCell>
                        <TextField
                          id="date"
                          label="Datum"
                          type="date"
                          value={today}
                          className={classes.textField}
                          onChange={dayChange}
                          InputLabelProps={{ shrink: true }}
                        />
                      </TableCell>

                      <TableCell width="100">Serial</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {deviceactionlogshash?.map((log, idx) => (
                      <TableRow
                        className={classes.tableRow}
                        hover
                        key={`${log.device_hash}-${log.eventTime}-${log.action?.serial ?? idx}`}
                      >
                        <TableCell>{idx + 1}</TableCell>

                        <TableCell>
                          <span className={classes.nameContainer}>
                            <Typography variant="body1">
                              {log.device_hash}
                            </Typography>
                          </span>
                        </TableCell>

                        <TableCell>
                          {moment(log.eventTime).fromNow()}
                          <br />
                          {moment(log.eventTime).format(
                            "DD MMMM YYYY, h:mm:ss a"
                          )}
                        </TableCell>

                        <TableCell>
                          <ListItem disableGutters>
                            <Grid
                              container
                              justifyContent="center"
                              alignItems="center"
                              spacing={2}
                            >
                              {Object.values(
                                log?.action?.status?.tubeStatus || []
                              ).map((state, i) => (
                                <Grid
                                  key={`${log.eventTime}-${i}`}
                                  item
                                  xs={4}
                                  sm={4}
                                  md={4}
                                  lg={4}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: 6,
                                    textAlign: "center"
                                  }}
                                >
                                  <Typography
                                    variant="body2"
                                    style={{ fontWeight: 600 }}
                                  >
                                    {i + 1}:
                                  </Typography>
                                  {state === 0 || state > 0 ? (
                                    <Icon code={state} />
                                  ) : (
                                    <span>-</span>
                                  )}
                                </Grid>
                              ))}
                            </Grid>
                          </ListItem>
                        </TableCell>

                        <TableCell>{log?.action?.serial}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </CardContent>
            </Card>
          </Grid>
        )}
      </Grid>
    </div>
  );
};

export default Notify;